module.exports = __webpack_public_path__ + "img/logo-rodape.14eb2f85.png";